import type { ReactNode } from 'react'
import styles from './ClientPageLayout.module.css'

interface ClientPageLayoutProps {
  children: ReactNode
  loading?: boolean
  empty?: boolean
  emptyMessage?: string
  emptyIcon?: string
  className?: string
}

export function ClientPageLayout({
  children,
  loading = false,
  empty = false,
  emptyMessage = 'Conteúdo em breve.',
  emptyIcon = '📭',
  className,
}: ClientPageLayoutProps) {
  return (
    <div className={`client-page-root ${styles.root} ${className ?? ''}`.trim()}>
      {loading ? (
        <div className={styles.state}>
          <span className={styles.stateIcon} aria-hidden>
            ⏳
          </span>
          <p>A carregar…</p>
        </div>
      ) : empty ? (
        <div className={styles.state}>
          <span className={styles.stateIcon} aria-hidden>
            {emptyIcon}
          </span>
          <p>{emptyMessage}</p>
        </div>
      ) : (
        <div className={styles.inner}>{children}</div>
      )}
    </div>
  )
}

export { styles as clientPageStyles }
